import { codeTransactionData } from './country-code-istransactional-v2.js';
import { errorLangMappings } from './error-lang-mappings-v2.js';
import {
  hideValidationMessage,
  showValidationMessage,
  emailValidation
} from '../form-validation-message.js';

const mrBeastPageActivate = (mrBeastMain, mrBeastReceiver) => {
  const mrBeastReceiverForm = mrBeastReceiver?.querySelector('#mrBeastReceiverForm')
  const mrbeastRegisterButton = document.getElementById('mrbeastRegisterButton')
  const mrBeastMainButton = mrBeastMain?.querySelector('#mrBeastMainButton')
  const beastModalMain = document.getElementById('beastModalMain')
  const inputCountryCode = mrBeastReceiverForm?.querySelector('#input-country-code')
  const countryFlagEl = mrBeastReceiverForm?.querySelector('#country-flag')
  const countryPhoneDropdown = mrBeastReceiverForm?.querySelector('#country-phone-dropdown')
  const wudsDropdown = mrBeastReceiverForm?.querySelector('.wuds-dropdown')
  const leftFlagSearch = mrBeastReceiverForm?.querySelector('.left-flag-search')
  const inputFirstname = mrBeastReceiverForm?.querySelector('#input-firstname')
  const inputLastname = mrBeastReceiverForm?.querySelector('#input-lastname')
  const inputPhone = mrBeastReceiverForm?.querySelector('#input-phone')
  const inputEmail = mrBeastReceiverForm?.querySelector('#input-email')
  const bannerBeast = document.querySelector('#bannerBeast')
  const subscribeMail = mrBeastReceiverForm?.querySelector('#subscribe-mail')
  const utm_source = getUrlParameter('utm_source')
  const utm_medium = getUrlParameter('utm_medium')
  const utm_campaign = getUrlParameter('utm_campaign')
  utm_source && CookieService.setCookie("utm_source", utm_source, 365)
  utm_medium && CookieService.setCookie("utm_medium", utm_medium, 365)
  utm_campaign && CookieService.setCookie("utm_campaign", utm_campaign, 365)
  const country = CookieService.getCookie('AKCountry') || 'US'
  const googleRecaptchaAdd = document.getElementById('googleRecaptchaAdd')
  const captchaAddPlace = mrBeastReceiverForm?.querySelector('#captchaAddPlace')
  const mrbformError = mrBeastReceiverForm?.querySelector('#mrbform-error')
  const countryLowerCase = country.toLowerCase()
  const language = pageData.language
  googleRecaptchaAdd?.classList.remove('d-none')
  const searchCountry = mrBeastReceiverForm?.querySelector("#search-country")
  let captchaValidated = !(window.sessionStorage.getItem('visibleCaptcha') || new URLSearchParams(window.location.search)?.get('visibleCaptcha'))
  const isInVisibleCaptcha = captchaValidated

  googleRecaptchaAdd && captchaAddPlace?.appendChild(googleRecaptchaAdd);
  !isInVisibleCaptcha && captchaAddPlace.classList.add('pad-xs-tp')

  const addSearchParams = (url) => {
    return window.location.search ? `${url}${window.location.search}` :  url
  }

  //Validation
  if(mrBeastReceiverForm) {
  const validationObj = {
    inputFirstname: "true", inputLastname: "true", inputPhone: "true",inputEmail: "true"
  }
  let isFormValidated = false
  document.addEventListener('captcha-error', () => {
    mrbeastRegisterButton.setAttribute('disabled', true)
    captchaValidated = false
  })

  document.addEventListener('captcha-success', () => {
    captchaValidated = true
    if(isFormValidated) {
      mrbeastRegisterButton.removeAttribute('disabled')
    }
  })

  const phoneValidation = (targetElement) => {
    return targetElement.value.match(phoneformat)
  }

  const validForm = new Proxy({}, {
    set: function(target, property, value) {
        let isValid = true
        validationObj[property] = value
        for (const [key, value] of Object.entries(validationObj)) {
          if (value === "false") {
            isValid = false
            isFormValidated = false
            mrbeastRegisterButton.setAttribute('disabled', true)
            break
          }
        }
        if(isValid) {
          isFormValidated = true
          captchaValidated && mrbeastRegisterButton.removeAttribute('disabled')
        }
        return target
    }
  });

  const errorBasedEventListener = (element, errorField) => {
    element.addEventListener('blur', (e) => {
      if(!e.target.value) {
        validForm[errorField] = "false"
        showValidationMessage(e.target)
      } else if ((element==inputEmail && !emailValidation(e.target)) || (element==inputPhone && !phoneValidation(e.target))) {
        validForm[errorField] = "false"
        showValidationMessage(e.target) 
      } else {
        validForm[errorField] = "true"
        hideValidationMessage(e.target)
      }
    })
  }

  // mrBeastReceiverForm.addEventListener('click', (e) => {
  //   showErrorForElements()
  // })

  // const showErrorForElements = () => {
  //   validationArr.forEach(([el, errorField]) => {
  //     if(!el.value) {
  //       validForm[errorField] = "false"
  //     } else if ((el==inputEmail && !emailValidation(el)) || (el==inputPhone && !phoneValidation(el))) {
  //       validForm[errorField] = "false"
  //     } else {
  //       validForm[errorField] = "true"
  //     }
  //   })
  // }

  let validationArr  = [
    [inputFirstname,"inputFirstname"],
    [inputLastname,'inputLastname'],
    [inputPhone,'inputPhone'],
    [inputEmail, 'inputEmail']
  ]

  validationArr.forEach(([el, errorField]) => {
      errorBasedEventListener(el, errorField)
  })
  }
  if(bannerBeast) {
    bannerBeast.classList.add('position-fixed', 'z-sticky')
    bannerBeast.classList.remove('mar-md-vert')
    bannerBeast.setAttribute('style', "bottom: 8px;")
  }

  const isElementVisible = function(el){
    var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height, 
      el = el.parentNode
    // Check if bottom of the element is off the page
    if (rect.bottom < 0) return false
    // Check its within the document viewport
    if (top > document.documentElement.clientHeight) return false
    do {
      rect = el.getBoundingClientRect()
      if (top <= rect.bottom === false) return false
      // Check if the element is out of view due to a container scrolling
      if ((top + height) <= rect.top) return false
      el = el.parentNode
    } while (el != document.body)
    return true
  };

  if(mrBeastMainButton) {

    document.addEventListener('scroll', () => {
      if(!isElementVisible(mrBeastMain) && window.innerWidth < 768) {
        bannerBeast.classList.remove('d-none')
      } else {
        bannerBeast.classList.add('d-none')
      }
    })
  
    mrBeastMainButton.addEventListener('click', (e) => {
      if(!country || !language) return;
      const dataCountry = codeTransactionData.filter((data) => {
        return data.iso === country && data.isTransactions
      })
      const customer = CookieService.getCookie('userIdentity')
      let isLanguageExisting = true
        if (dataCountry.length === 0 || (language !== 'en' && !dataCountry[0].languages)) {
          isLanguageExisting = false
        } else if (language !== 'en' &&  dataCountry[0].languages.indexOf(language.toLowerCase()) > -1) {
          isLanguageExisting = true
        } else if(language !== 'en') {
          isLanguageExisting = false
        }
      const languageToUse = isLanguageExisting ? language : 'en'  
      if(dataCountry.length !== 0) {
        if(!customer || customer==='newCustomer') {
          location.href = addSearchParams(`/${countryLowerCase}/${languageToUse}/web/user/register`)
        } else {
          location.href = addSearchParams(`/${countryLowerCase}/${languageToUse}/web/user/login`)
        }
      } else {
        location.href = addSearchParams(`/${languageToUse}/mrbeast/receiver.html`)
      }
    })
  }

  if(mrBeastReceiverForm) {
    const dropwonActiveClassAdd = (visible) => {
      if(visible) {
        toggleClass(countryPhoneDropdown, 'd-none','d-block')
        wudsDropdown.classList.add('wuds-dropdown--active')
      } else {
        toggleClass(countryPhoneDropdown, 'd-block','d-none')
        wudsDropdown.classList.remove('wuds-dropdown--active')
      }

    }
    window.addEventListener('click', e => {
      if (e.target.closest('.b-flag-select') === null) {
        dropwonActiveClassAdd(false)
      }
    })
    if(countryPhoneDropdown) {
      codeTransactionData.forEach((obj) => {
        let fragment = document.createDocumentFragment();
        let li = document.createElement('li');
        li.className = `wuds-dropdown__items b-flag-select__item `
        let countryNameEL = document.createElement('span')
        countryNameEL.className = `wuds-dropdown__item-text`
        countryNameEL.innerText = `${obj.country} (+${obj.code})`
        let icon = document.createElement('i')
        icon.className = `wu-flag ${obj.iso.toLowerCase()} wu-flagSize--S`
        li.appendChild(icon)
        li.appendChild(countryNameEL)
        fragment.appendChild(li)
        countryPhoneDropdown.appendChild(fragment)
        li.addEventListener('mousedown', (e) => {
          inputCountryCode.value = `+${obj.code}`
          countryFlagEl.classList.remove(countryFlagEl.getAttribute('countrycode'))
          inputCountryCode.setAttribute('value', inputCountryCode.value)
          countryFlagEl.setAttribute('countrycode', obj.iso.toLowerCase())
          countryFlagEl.classList.add(obj.iso.toLowerCase())
          dropwonActiveClassAdd(false)
        })
      })
    }

    [inputFirstname, inputLastname, inputPhone, inputEmail, inputCountryCode].forEach((el) => {
      if(!el) return;
      el.addEventListener('input', ({target}) => {
        toggleClass(mrbformError,'d-flex','d-none')
        target.setAttribute('value', target.value)
      })
    })
  
    if(inputCountryCode) {
      inputCountryCode.value = `+${codeTransactionData.filter((obj) => obj.iso === country)[0]['code']}`
      inputCountryCode.setAttribute('value', inputCountryCode.value)
      // leftFlagSearch.addEventListener('click', (e) => {
      //   if(countryPhoneDropdown.classList.contains('d-none')) {
      //     dropwonActiveClassAdd(true)
      //   } else {
      //     dropwonActiveClassAdd(false)
      //   }
      // })
      inputCountryCode.addEventListener('input', (e) => {
        let value = e.target.value;
        let lis = countryPhoneDropdown.querySelectorAll('li')
        Array.from(lis).forEach((li) => {
          if(li.innerText === ' ') {
          } else if (li.innerText.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
            li.classList.remove('d-none')
          } else {
            li.classList.add('d-none')
          }
        })
      })

      const searchCountryActiveEvent = (e) => {
        if(wudsDropdown.classList.contains('wuds-dropdown--active')) {
          dropwonActiveClassAdd(false)
        } else {
          dropwonActiveClassAdd(true)
        }
      }

      searchCountry.addEventListener('keydown', (e) => {
        if(e.keyCode === 13 || e.key === 'Enter') {
          searchCountryActiveEvent(e)
        }
      })
      searchCountry.addEventListener('click', searchCountryActiveEvent)
      searchCountry.addEventListener('blur', dropwonActiveClassAdd.bind({}, false))
      inputCountryCode.addEventListener('focus', dropwonActiveClassAdd.bind({},true))
      inputCountryCode.addEventListener('click', dropwonActiveClassAdd.bind({},true))

      inputCountryCode.addEventListener('blur',(ev) => {
        if(ev.relatedTarget !== searchCountry) {
          dropwonActiveClassAdd(false)
        }
      })
    }
  
    if(countryFlagEl) {
      countryFlagEl.setAttribute('countrycode', countryLowerCase)
      countryFlagEl.classList.remove(countryFlagEl.getAttribute('countrycode'))
      countryFlagEl.classList.add(countryLowerCase)
    }
  
    mrBeastReceiverForm?.addEventListener('submit', async (e) => {
      const spinnerEl = document.getElementById('spinnerContainer')
      try {
        e.preventDefault()
        const { sessionId } = await triggerRouterCreateSession(country, language)
        showSpinnerMain(spinnerEl)
        let tokenfromRecaptcha = ''
        if(isInVisibleCaptcha) {
          tokenfromRecaptcha = await grecaptcha.execute()
        } else {
          tokenfromRecaptcha = document.getElementById('captchaHumanKey').value
        }
        const uuidGenerated = `mrb@${Math.random().toString(36).slice(-12)}`;
        const registerUserData =  await window.triggerPartialRegistration(sessionId, country, language, '', 'registration', uuidGenerated, inputCountryCode.value, inputPhone.value, inputFirstname.value, '' , inputLastname.value, '', false, undefined, inputEmail.value, tokenfromRecaptcha, subscribeMail.checked)
        let erroCodeFromApi = registerUserData?.errorCode || registerUserData?.error?.errorCode
        if(erroCodeFromApi) {
          const errorcode = erroCodeFromApi !== 'C9300' ? erroCodeFromApi: 'C1052'
          let errorObj = errorLangMappings[errorcode] || errorLangMappings['other']
          const errorMessage = errorObj[language] || errorObj["en"]
          toggleClass(mrbformError, 'd-none', 'd-flex')
          mrbformError.scrollIntoView()
          if(mrbformError.querySelector('.input-form-error')) mrbformError.querySelector('.input-form-error').innerText = errorMessage
        }
        if(registerUserData.status === 'CREATED') {
          location.href = addSearchParams(`/${language}/mrbeast/success.html`)
        }
      } catch(e) {
        hideSpinnerMain(spinnerEl)
        console.error(e)
      }
      // toggleClass(beastModalMain, 'd-none', 'd-flex')
    })

  }
}
const mrBeastMain = document.getElementById('mrBeastMain')
const mrBeastReceiver = document.getElementById('mrBeastReceiver')
const mrBeastSuccess = document.getElementById('mrBeastSuccess') 
if(mrBeastMain || mrBeastReceiver) {
  mrBeastPageActivate(mrBeastMain, mrBeastReceiver)
}
if(mrBeastSuccess || mrBeastMain || mrBeastReceiver) {
  const footerImpLinks =  document.querySelectorAll('#footerImpLinks .wu-link ,.wu-header__container .wu-logo,.wu-logo.wu-footer__logo-section__logo')
  const akCountryCookie = CookieService.getCookie('AKCountry') || 'us'
  Array.from(footerImpLinks).forEach((footerLinks) => {
    const nongGLobalHref = footerLinks.getAttribute('href')?.startsWith('/us/en/')
    const isGlobal = footerLinks.getAttribute('is-global')
    if((isGlobal === 'false' || nongGLobalHref) && akCountryCookie) {
      const href =  footerLinks.getAttribute('href')
      const hrefSplit = href.split('/')
      hrefSplit[1] = akCountryCookie?.toLowerCase()
      hrefSplit[2] = 'en'
      footerLinks.setAttribute('href', hrefSplit.join('/'))
    }
  })
}